/**
 * Общая обвязка страниц входа: знак, заголовок, карточка.
 *
 * Все пять путей — вход, подтверждение почты, восстановление, новый пароль,
 * приглашение — приходят на один и тот же экран, поэтому и рамка у них одна.
 * Разъехавшиеся карточки входа читаются как разные сервисы, а человек и так
 * попал сюда по ссылке из письма и не вполне уверен, куда именно.
 */

import type { ReactNode } from 'react';
import { Mark } from '../../ui/Mark';

export function AuthCard({
  title,
  lead,
  children,
  footer,
}: {
  title: string;
  /** Одно предложение под заголовком. Не обязательно, но чаще нужно. */
  lead?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <main className="auth">
      <div className="auth-card">
        <div className="brand">
          <Mark />
          seeno
        </div>

        <h1>{title}</h1>
        {lead ? <p className="auth-lead">{lead}</p> : null}

        {children}

        {footer ? <div className="auth-foot">{footer}</div> : null}
      </div>
    </main>
  );
}

/**
 * Кнопка входа через Яндекс ID — единственного провайдера РФ-версии.
 *
 * На портале агентства её нет вовсе: `redirect_uri` не регистрируется под
 * произвольное число чужих доменов, и кнопка, ведущая в никуда, хуже её
 * отсутствия.
 */
export function YandexButton({
  onClick,
  disabled,
}: {
  onClick: () => void;
  disabled?: boolean;
}) {
  return (
    <>
      <p className="auth-or">
        <span>или</span>
      </p>
      <button
        className="btn btn-ghost"
        type="button"
        onClick={onClick}
        disabled={disabled}
      >
        Войти через Яндекс ID
      </button>
    </>
  );
}
